import { setInternationalBuyBox } from './shared-state.js';
import { CookieUtils } from './Shared/cookies/cookie-utils';

export default class InternationalBuyBox {
   constructor(productcode) {
      const endpoint = 'internal/international_store_promotion/buybox';
      const queryParams = { productcode: productcode };

      const reqCountry = getURLParameter('country');
      if (reqCountry) {
         queryParams.country = reqCountry;
      }

      // To start paying attention to whether or not the user has already
      // dismissed the modal elsewhere:
      // Boolean(Cookie.read('hideIntlStoreModal'))
      this.isDisabled = false;
      this.productcode = productcode;

      this.cachedResponse = null;
      this.response = this.isDisabled
         ? Promise.resolve(null)
         : new Request.API_2_0(endpoint, { queryParams }).send();
   }

   setupAndThen(optionid, containerDiv, onSetup) {
      this.withResponse(response => {
         if (this.isDisabled || !response) {
            setInternationalBuyBox(false);
            return;
         }

         // We only want to send users to the alternate store if they have
         // exactly the same product.
         const products = response.products;
         const product = products[optionid] || getFirstProduct(products);

         if (!product) {
            setInternationalBuyBox(false);
            return;
         }

         const sku = this.productcode + '-' + optionid;

         setupFlag(response.countryCode, containerDiv);
         setupBuyCopy(response.storeName, containerDiv);
         setupBuyLink(sku, product.productURL, response.salesChannel, containerDiv);

         onSetup(response);
      });
   }

   disableAndThen(onDisable) {
      setInternationalBuyBox(false);
      if (this.isDisabled) {
         return;
      }
      // If the user has opted out of going to the international store here, we
      // shouldn't show them the modal on other pages.
      CookieUtils.set('hideIntlStoreModal', true, { maxAgeInSeconds: 604800 /* 7 days */ });
      this.isDisabled = true;
      onDisable();
   }

   setupFFP(intlBuyBoxDiv, addToCartButton, localPriceDiv, rejectLink) {
      if (rejectLink) {
         rejectLink.addEvent('click', function(ev) {
            ev.preventDefault();
            intlBuyBoxDiv.addClass('hidden');

            addToCartButton.removeClass('hidden');
            localPriceDiv.removeClass('hidden');
         });
      }

      intlBuyBoxDiv.addClass('hidden');
      this.setupAndThen(App.optionid, intlBuyBoxDiv, function() {
         intlBuyBoxDiv.removeClass('hidden');

         addToCartButton.addClass('hidden');
         localPriceDiv.addClass('hidden');
      });
   }

   // We store the response we get back from the API request promise because
   // successive calls to then() appear to allow a repaint, even though the
   // promise has already been resolved. After the initial request, we want
   // calls to setupAndThen() to be completely synchronous so that the UI
   // doesn't flicker as we show some nodes and then hide them again based on
   // the API response.
   withResponse(callback) {
      if (this.cachedResponse) {
         callback(this.cachedResponse);
      } else {
         this.response
            .then(response => {
               this.cachedResponse = response;
               callback(response);
            })
            .catch(function(err) {
               setInternationalBuyBox(false);
               console.error(err);
            });
      }
   }
}

// IE11 doesn't support NodeList.forEach(), and we want to do a lot of
// iterating over NodeLists.
function each(containerDiv, selector, callback) {
   const list = containerDiv.querySelectorAll(selector);
   Array.prototype.forEach.call(list, callback);
}

// If there are products, returns the first one ordered by optionid ascending;
// otherwise, null.
function getFirstProduct(products) {
   const options = Object.values(products).sort((a, b) => {
      return a.optionid - b.optionid;
   });

   return options.length > 0 ? options[0] : null;
}

function setupFlag(countryCode, containerDiv) {
   each(containerDiv, '.js-intl-buy-box-country-flag', img => {
      img.setAttribute('src', setCountryCode(img.getAttribute('data-src'), countryCode));

      img.setAttribute('srcset', setCountryCode(img.getAttribute('data-srcset'), countryCode));
   });
}

function setCountryCode(templateStr, countryCode) {
   return templateStr.replace('{countryCode}', countryCode);
}

function setupBuyCopy(storeName, containerDiv) {
   each(containerDiv, '.js-intl-buy-box-copy', a => {
      a.textContent = a.textContent.replace('{storeName}', storeName);
   });
}

function setupBuyLink(sku, productUrl, salesChannel, containerDiv) {
   each(containerDiv, '.js-intl-buy-box-link', oldAnchor => {
      // clone the element to destroy the old event listener
      let newAnchor = oldAnchor.cloneNode(true);
      oldAnchor.parentNode.replaceChild(newAnchor, oldAnchor);

      newAnchor.setAttribute('href', productUrl);
      const category = salesChannel + ' Store Buy Box';
      trackLink(newAnchor, category, 'click', sku);
   });
}
